import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';
import { useDropzone, } from 'react-dropzone';

import { PaymentInformation, PaymentInformationWithDetails } from '../../classess/paymentInformation/paymentInformation';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, checkFile, convertFileAsync, getDocumentMaxFilesMessage, isUndNullEmp, getLanguageObj,
    getNoImage, getResponse, handleResponseMessageAsync, settings, styles
} from '../../helpers/main';
import { PaymentInformationService } from '../../services/paymentInformation/PaymentInformationService';
import { userAuthContextType } from '../../auth/AuthProvider';

const currentMethod = 'PaymentInformationAdd';

const { backend, files, icons, images, labels, messages, } = settings;

export default function PaymentInformationAdd({
    modalObj = {
        $: {},
        type: 0,
        auth: { user: userAuthContextType, },
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtPaymentInformationsId: '',
        dtPaymentInformationsRowId: 0,
        userRole: '',
    },
    setModalObj = {},
    paymentInformation = PaymentInformation?.class({}, false),
    setPaymentInformation = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const [process, setProcess] = useState({ showLoading: false, save: false });
    const [errors, setErrors] = useState({ name: '' });
    const [dataFormLength] = useState(PaymentInformation.minMaxLength(false));
    const fileObjEmpty = { lastModified: 0, lastModifiedDate: {}, name: '', path: '', preview: '', size: 0, type: '', webkitRelativePath: '', };
    const [filesState, setFilesState] = useState(fileObjEmpty);
    const fileTypes = files?.acceptedTypes?.images?.concat([]);
    const { getRootProps, getInputProps } = useDropzone({
        accept: settings?.react?.dropZone?.imagesAccepted,
        onDrop: async (acceptedFiles) => {
            const currentMethod = 'dropZone - onDrop';
            let response = getResponse({ type: 0 });
            try {
                if (!isUndNullEmp({ data: acceptedFiles, subMethod: currentMethod })?.result && acceptedFiles?.length > 0) {
                    if (acceptedFiles?.length <= files?.paymentInformation?.logo.quantity) {
                        const fileObj = acceptedFiles[0] || fileObjEmpty;
                        response = checkFile({
                            type: fileObj.type,
                            size: fileObj.size,
                            allowedTypes: fileTypes,
                            maxSize: files?.paymentInformation?.logo?.maxSize,
                            languageId: modalObj?.languageObj?.id,
                            subMethod: currentMethod
                        });

                        if (!response?.isSuccess || response?.isWarning) return;

                        fileObj.preview = URL.createObjectURL(fileObj);
                        setFilesState(() => fileObj);

                        response = await convertFileAsync.toBase64URL({
                            file: acceptedFiles[0],
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) return;

                        setPaymentInformation(prev => ({
                            ...prev,
                            logo: response?.result,
                        }));
                    } else {
                        response = getDocumentMaxFilesMessage({
                            maxFiles: files?.paymentInformation?.logo.quantity,
                            languageId: modalObj?.languageObj?.id,
                            subMethod: currentMethod,
                        });
                    }
                }
            } catch (ex) {
                response = getResponse({ type: -1 });
                response.msgText = `Method: ${currentMethod}<br/>`;
                response.msgText += `Error: ${ex?.message}<br/>`;
            } finally {
                if (!isMount?.current) return;
                // CSN:
                if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                    await handleResponseMessageAsync({ response, currentMethod, auth: modalObj?.auth, languageId: modalObj?.languageObj?.id });
                }
            }
        },
    });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-sm btn-outline-success',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-sm btn-outline-primary mx-1',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close btn-danger fas fa-window-close',
                id: 'btnModalClose',
            },
        },
        dropzone: {
            logo: {
                id: 'dzModalLogo',
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            logo: {
                id: 'inputModalLogoId',
            },
            name: {
                id: 'inputModalName',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    const addPaymentInformation = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'addPaymentInformation';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            response = await PaymentInformationService.create({
                data: paymentInformation,
                token: modalObj?.auth?.user?.token?.token,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const modelPaymentInformationWithDetails = PaymentInformationWithDetails.class(
                response?.result?.paymentInformation || {},
                false
            );
            setPaymentInformation(() => modelPaymentInformationWithDetails);

            let logoUrl = modelPaymentInformationWithDetails?.logo || '';
            if (!isUndNullEmp({ data: logoUrl, subMethod: currentMethod })?.result) {
                logoUrl = logoUrl.replace(
                    '~/Images/Logos/PaymentInformation/',
                    `${backend?.urls?.imageLogos}${backend?.urls?.paymentInformations}/`
                );
                logoUrl = `${backend?.urls?.api}${logoUrl}`;
            } else {
                logoUrl = `${backend?.urls?.api}${images?.noImage}`;
            }

            const logo = `<img alt='paymentLogo' src='${logoUrl}' height='auto' width='60px'/>`;
            const processButtons = [];
            const dataDt = [
                modelPaymentInformationWithDetails.name,
                logo,
                modelPaymentInformationWithDetails?.accounts?.length || 0,
                getProcessButtons({
                    id: modelPaymentInformationWithDetails.id,
                    description: modelPaymentInformationWithDetails.name,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRole === settings?.roles?.admin,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRole === settings?.roles?.admin,
                    showEdit: modalObj?.userRole === settings?.roles?.admin,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRole === settings?.roles?.admin,
                    processButtons: processButtons,
                })?.result,
            ];

            modalObj?.$(`#${modalObj.dtPaymentInformationsId}`).DataTable().row.add(dataDt)?.draw(true);

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth: modalObj?.auth, languageId: modalObj?.languageObj?.id });
            }
        }
    }

    const editPaymentInformation = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editPaymentInformation';
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            response = await PaymentInformationService.update({
                data: paymentInformation,
                token: modalObj?.auth?.user?.token?.token,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const modelPaymentInformationWithDetails = PaymentInformationWithDetails.class(
                response?.result?.paymentInformation || {},
                false
            );
            setPaymentInformation(() => modelPaymentInformationWithDetails);

            let logoUrl = modelPaymentInformationWithDetails?.logo || '';
            if (!isUndNullEmp({ data: logoUrl, subMethod: currentMethod })?.result) {
                logoUrl = logoUrl.replace(
                    '~/Images/Logos/PaymentInformation/',
                    `${backend?.urls?.imageLogos}${backend?.urls?.paymentInformations}/`
                );
                logoUrl = `${backend?.urls?.api}${logoUrl}`;
            } else {
                logoUrl = `${backend?.urls?.api}${images?.noImage}`;
            }

            const logo = `<img alt='paymentLogo' src='${logoUrl}' height='auto' width='60px'/>`;
            const processButtons = [];
            const dataDt = [
                modelPaymentInformationWithDetails.name,
                logo,
                modelPaymentInformationWithDetails?.accounts?.length || 0,
                getProcessButtons({
                    id: modelPaymentInformationWithDetails.id,
                    description: modelPaymentInformationWithDetails.name,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRole === settings?.roles?.admin,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRole === settings?.roles?.admin,
                    showEdit: modalObj?.userRole === settings?.roles?.admin,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRole === settings?.roles?.admin,
                    processButtons: processButtons,
                })?.result,
            ];

            modalObj?.$(`#${modalObj?.dtPaymentInformationsId}`).DataTable().row(modalObj?.dtPaymentInformationsRowId).data(dataDt)?.draw(true);

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth: modalObj?.auth, languageId: modalObj?.languageObj?.id });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmp({ data: paymentInformation, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: paymentInformation?.name, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({ ...prev, name: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const showDropZone = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'showDropZone';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            if (!process?.save) {
                modalObj?.$(`#${controls?.dropzone?.logo?.id}`).trigger('click');
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        }
    }, []);
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='paymentInformations'
                            src={images?.icons?.paymentInformation}
                            style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.paymentInformation?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                                style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: 'btnCloseModal', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => modalObj?.type === 0 ?
                addPaymentInformation({ e: e, subMethod: currentMethod }) :
                modalObj?.type === 1 ? editPaymentInformation({ e: e, subMethod: currentMethod }) :
                    e.preventDefault()}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-12 col-md-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.creditCard} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.name?.id}
                                            className='form-control bg-light border-0 shadow-sm text-dark'
                                            style={{ borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.name}
                                            disabled={process?.save}
                                            onChange={(e) => setPaymentInformation(prev => ({ ...prev, name: e?.target?.value }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                            value={!isUndNullEmp({ data: paymentInformation, subMethod: currentMethod, })?.result && !isUndNullEmp({ data: paymentInformation?.name, subMethod: currentMethod, })?.result ?
                                                paymentInformation.name : ''}
                                            placeholder={labels?.name?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text text-danger small mt-1 animated fadeIn' style={styles?.inputMsgAlert}>{parse(errors?.name)}</div>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 d-flex align-items-center justify-content-center mt-3'>
                                    <div className='col-4' style={{ cursor: process?.save ? 'default' : 'pointer' }}>
                                        <a href='#logoPreview'
                                            className='d-block shadow-sm rounded bg-light border'
                                            style={{ width: '80px', height: '80px', padding: '10px', transition: 'all 0.3s ease', borderRadius: '5px' }}
                                            onClick={(e) => { showDropZone({ e: e, subMethod: 'logoPreview', }) }}>
                                            <img alt='logoPreview'
                                                className='w-100 h-100'
                                                style={{ objectFit: 'fill' }}
                                                src={filesState?.preview || getNoImage({ processType: 1, subMethod: currentMethod, })?.result} />
                                        </a>
                                    </div>
                                    <div className='col-8'>
                                        <a href='#logoPreview'
                                            style={{ width: '80px', height: '80px', padding: '10px', transition: 'all 0.3s ease', borderRadius: '5px' }}
                                            onClick={(e) => { showDropZone({ e: e, subMethod: 'logoPreviewLbl', }) }}>
                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-3'>
                                                <i className={icons?.fasFa?.camera} /> {messages?.clickToDefineTheLogo?.[modalObj?.languageObj?.id]}
                                            </small>
                                        </a>
                                    </div>

                                </div>

                                <div className='col-12'>
                                    <div hidden {...getRootProps({ className: 'dropzone' })}>
                                        <input id={controls?.dropzone?.logo?.id} {...getInputProps()} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='row'>
                                <div className='col-12 col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.creditCard} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h5 mb-0 font-weight-bold text-dark'>{paymentInformation?.name || '---'}</span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-12 text-center mt-3'>
                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-3' style={settings?.html?.labels?.detailMicro}>
                                        <i className={`${icons?.fasFa?.image} mr-2`} /> {labels?.logo?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <div className='d-inline-block p-3 rounded bg-white shadow-sm border'>
                                        <img alt='logoDetail'
                                            style={{ width: '120px', height: '120px', objectFit: 'contain' }}
                                            src={!isUndNullEmp({ data: paymentInformation?.logo, subMethod: currentMethod })?.result ?
                                                paymentInformation?.logo :
                                                getNoImage({ processType: 1, subMethod: currentMethod, })?.result
                                            } />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            // onClick={(e) => modalObj?.type === 0 ? addPaymentInformation({ e: e, subMethod: currentMethod }) : modalObj?.type === 1 ? editPaymentInformation({ e: e, subMethod: currentMethod }) : e.preventDefault()}
                            // type='button'>
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i className={`${icons?.fasFa?.save}`} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className='btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i className={`${icons?.fasFa?.arrowCircleLeft}`} /> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}